module.exports = __webpack_public_path__ + "img/star-complete.eb8f9213.svg";